// src/locales/en/footer.js
export const footer = {
    madeWithLove: "Made with ❤️ for Sri Lankan businesses",
    helpCenter: "Help Center",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    documentation: "Documentation",
    copyright: "© {{year}} Rettzy"
}